import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import es from "./locales/es.json";
import en from "./locales/en.json";

export const SUPPORTED_LANGUAGES = ["es", "en"];
export const DEFAULT_LANGUAGE = "es";
export const LANGUAGE_STORAGE_KEY = "cgmg-lang";

// Order: an explicit ?lang=en link wins, then the visitor's saved choice from
// the language switcher. Otherwise the site is in Spanish, its primary
// language. The browser language is deliberately NOT used: Googlebot renders
// pages as en-US, and the Spanish site is what must be indexed for local
// searches (transportes en Delicias / Chihuahua).
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    supportedLngs: SUPPORTED_LANGUAGES,
    nonExplicitSupportedLngs: true, // es-MX -> es, en-US -> en
    load: "languageOnly",
    fallbackLng: DEFAULT_LANGUAGE,
    detection: {
      order: ["querystring", "localStorage"],
      lookupQuerystring: "lang",
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false }, // React already escapes
    initImmediate: false, // resources are bundled: initialise synchronously, no Suspense flash
    react: { useSuspense: false },
  });

export default i18n;
